$(document).ready(function () {

  $('.owl-carousel').owlCarousel({
      loop: true,
      // margin: 10,
      margin: 10,
      // nav: true,
      dots: false,
      nav: true,
      autoplay: true,
      autoplayTimeout: 5000,
      // stagePadding: 50,
      // stagePadding: 100,
      responsive: {
          0: {
              items: 1
          },
          600: {
              items: 3
          },
          1000: { // min-width: 1000
              items: 4 // show 5 items
              // items: 3
          }
      }
  });

  $(".owl-prev").html(`<div class="option-arrow-left">
  <img src="${window._icons.arrowLeft}" alt="">
</div>`);

  $(".owl-next").html(`<div class="option-arrow-right">
  <img src="${window._icons.arrowRight}" alt="">
</div>`);
});

